import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import ThreadsPanel from "./comments/ThreadsPanel";
import HighlightedThread from "./comments/HighlightedThread";
import { useRemoveCommentUrlParams } from "./comments/removeCommentUrlParams";

const CommentsPane = ({
  cuid,
  onAudioJumpPosition,
  commentReferences,
  removeCommentReferences,
  scrollToNewComment,
  onScrolledToNewComment,
  onAddCallReference
}) => {
  const highlightedThreadHashid = new URLSearchParams(useLocation().search).get("thread_id");
  const removeCommentUrlParams = useRemoveCommentUrlParams();

  useEffect(() => {
    if (highlightedThreadHashid && commentReferences && Object.keys(commentReferences).length > 0) {
      removeCommentUrlParams();
    }
  });

  return (
    <div className="pt-1 pr-3">
      {highlightedThreadHashid
        ? <HighlightedThread threadHashid={highlightedThreadHashid} onAudioJumpPosition={onAudioJumpPosition} />
        : <ThreadsPanel
          cuid={cuid}
          scrollToNewComment={scrollToNewComment}
          onScrolledToNewComment={onScrolledToNewComment}
          commentReferences={commentReferences}
          removeCommentReferences={removeCommentReferences}
          onAddCallReference={onAddCallReference}
          onAudioJumpPosition={onAudioJumpPosition}
        />
      }
    </div>
  );
};

CommentsPane.propTypes = {
  cuid: PropTypes.string.isRequired,
  onAudioJumpPosition: PropTypes.func,
  commentReferences: PropTypes.object,
  removeCommentReferences: PropTypes.func,
  scrollToNewComment: PropTypes.bool,
  onScrolledToNewComment: PropTypes.func,
  onAddCallReference: PropTypes.func
};

export default CommentsPane;
